
import React from "react";
import PersonIcon from '@material-ui/icons/Person';


const PeopleIcon = () => (<PersonIcon />);

export default PeopleIcon;
